// extracted by mini-css-extract-plugin
export var footer = "_pw-0";
export var inherit = "_pw-1";
export var input = "_pw-2";
export var modalContent = "_pw-3";
export var quillEditor = "_pw-4";
export var subtitle = "_pw-5";